import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";

export interface NavItem {
  key: "home" | "rent" | "requests" | "settings";
  title: string;
  urlPath: string;
  disabled: boolean;
}

/**
 * Single source of truth for the app's primary navigation, consumed by both
 * SideNav (desktop) and MobileTabBar. The Rent tab's KYC gating (previously
 * inline in MainMenu) lives here.
 *
 * Note: `isKycSucces` in localStorage is legacy state carried as-is — see
 * redesign plan (tech debt, not addressed here).
 */
export const useNavItems = (): NavItem[] => {
  const { t } = useTranslation();
  const { tpExistingUserIdentityVerification } = useFlags();
  const isCompletedKYC = localStorage.getItem("isKycSucces");

  const rentDisabled =
    isCompletedKYC === "false" && Boolean(tpExistingUserIdentityVerification);

  return [
    {
      key: "home",
      title: t("menu.dashboard"),
      urlPath: "/home",
      disabled: false,
    },
    {
      key: "rent",
      title: t("menu.rent"),
      urlPath: "/rent",
      disabled: rentDisabled,
    },
    {
      key: "requests",
      title: t("menu.requests"),
      urlPath: "/requests",
      disabled: false,
    },
    {
      key: "settings",
      title: t("menu.settings"),
      urlPath: "/settings",
      disabled: false,
    },
  ];
};
